import { clamp } from 'es-toolkit';

export const estimateRemainingTime = (
  startTime: number,
  chunkNumber: number,
  totalChunks: number,
): number => {
  const chunkEndTimeStamp = Date.now();
  const elapsedTime = chunkEndTimeStamp - startTime;
  const chunksProcessed = chunkNumber;
  const chunksRemaining = totalChunks - chunksProcessed;
  const remainingTime = (elapsedTime * chunksRemaining) / chunksProcessed;

  return clamp(0, remainingTime, remainingTime);
};
